import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';

@customElement('ils-start-button')
export class ILSStartButton extends ChemistryLitElement {
  override styles() {
    return [
      {
        ':host': {
          display: 'block',
          position: 'relative',
          height: this.spacing.xl,
          width: '150px',
          borderRadius: this.sizes.borderRadius!,
          overflow: 'hidden',
          background: this.colors.accent.shade(200),
          cursor: 'pointer',
          userSelect: 'none',
          boxShadow: '1px 3px 9px 0px rgba(0,0,0,0.5) !important',
          transition: 'box-shadow .12s ease',
        },
        ':host(:hover)': {
          boxShadow: '1px 2px 4px 0px rgba(0,0,0,0.4) !important',
        },
        ':host(:active)': { boxShadow: 'none' },
        '#progress': {
          position: 'relative',
          height: '100%',
          width: '100%',
          background: this.colors.accent,
          transformOrigin: 'left',
          transition: `transform 0.95s linear`,
        },
      },
    ];
  }

  @state() public currentTime = 1;
  @state() public progress = 0;
  @state() size = new WindowSizeController(this);

  override render() {
    return html`
      <div id="progress" ${css({ transform: `scaleX(${this.progress.toFixed(2)})` })}></div>
      <x-flex center crossaxis-center ${css({ position: 'absolute', top: '0', left: '0', bottom: '0', right: '0' })}>
        <x-text bold ${css({ color: this.colors.on.accent })}> Start (${Math.floor(this.currentTime ?? 0)}) </x-text>
      </x-flex>
    `;
  }
}
